import Pubnub from "pubnub";
import { PubNubProvider } from "pubnub-react";
import ChatV3 from "subviews/ChatV3";
import config from "../config/config";

function ChatWidgetBody({ clinicId }) {
  const pubnub = new Pubnub({
    publishKey: config.PUBLISH_KEY,
    subscribeKey: config.SUBSCRIBE_KEY,
    uuid: clinicId,
  });

  return (
    <PubNubProvider client={pubnub}>
      <ChatV3 />
    </PubNubProvider>
  );
}

export default ChatWidgetBody;
